const Promise = window.Promise

export default Promise